module.exports = __webpack_public_path__ + "img/culture.5d4765b1.png";